var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudVictim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60.0 60.0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680,0 L1680,1080 L0,1080 L0,0 L1680,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.992,0 L15.0792071,0.00658161866 C15.3021975,0.0413580247 15.446,0.211333333 15.446,0.454 L15.446,3.68 L15.7381249,3.69511985 C21.4647381,4.06630278 26.0807833,8.77466667 26.304,14.537 L29.529,14.537 L29.6165048,14.5436159 C29.8401975,14.5785679 29.984,14.7493333 29.984,14.992 L29.9773841,15.0794705 C29.9424321,15.3029877 29.7716667,15.446 29.529,15.446 L26.304,15.446 L26.2888801,15.7381249 C25.9176969,21.4647381 21.2093167,26.0807833 15.446,26.304 L15.446,29.53 L15.4394184,29.6172071 C15.404642,29.8401975 15.2346667,29.984 14.992,29.984 L14.9047929,29.9773855 C14.6818025,29.9424444 14.538,29.7717778 14.538,29.53 L14.538,26.304 L14.2458751,26.2888801 C8.51926194,25.9176969 3.90321667,21.2093167 3.68,15.446 L0.455,15.446 L0.367495199,15.4394184 C0.143802469,15.404642 0,15.2346667 0,14.992 L0.00661591221,14.9044952 C0.0415679012,14.6808025 0.212333333,14.537 0.455,14.537 L3.679,14.537 L3.69416902,14.2449235 C4.06630306,8.51922917 8.77468333,3.90223333 14.538,3.68 L14.538,0.454 C14.538,0.181 14.719,0 14.992,0 Z M15.7281657,25.3792016 C20.9587313,25.0137091 25.171193,20.7129298 25.35,15.445 L25.395,14.538 L25.39,14.543 L24.305,15.727 L22.475,17.724 L21.007,19.326 L15.447,25.395 Z M14.537,4.588 L14.2558343,4.60374762 C9.02526839,4.96832533 4.81278947,9.27005263 4.633,14.537 L4.588,15.446 L4.60374853,15.7272174 C4.9683598,20.9587313 9.27103509,25.171193 14.537,25.35 L15.446,25.395 L21.007,19.326 L22.475,17.724 L24.305,15.727 L25.39,14.543 L25.3792524,14.2558334 C25.0146747,9.02523423 20.7129474,4.81182456 15.446,4.634 L14.538,4.589 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.984,0 L31.984,31.984 L0,31.984 L0,0 L31.984,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.086,0.234970526 C3.135,0.406970526 3.036,0.587970526 2.864,0.637970526 C1.561,1.01397053 0.654,2.22797053 0.654,3.58397053 C0.654,5.27697053 2.03,6.65297053 3.722,6.65297053 L8.065,6.65297053 C8.243,6.65297053 8.392,6.79897053 8.392,6.97997053 C8.392,7.16197053 8.243,7.30997053 8.065,7.30997053 L3.722,7.30997053 C1.67,7.30997053 0,5.63997053 0,3.58797053 C0,1.94097053 1.102,0.472970526 2.683,0.0139705261 C2.858,-0.0390294739 3.036,0.0639705261 3.086,0.234970526 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.874,0 C5.165,0 6.362,0.637 7.085,1.706 C7.187,1.855 7.148,2.059 6.999,2.158 C6.851,2.261 6.65,2.221 6.547,2.073 C5.947,1.182 4.947,0.65 3.874,0.65 C2.129,0.65 0.654,2.188 0.654,4.006 C0.65,4.188 0.505,4.333 0.327,4.333 C0.149,4.333 0,4.188 0,4.006 C0,1.835 1.776,0 3.874,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.313,0 C2.679,0 3.838,1.207 3.867,2.646 C3.871,2.663 3.871,2.679 3.867,2.696 C3.864,2.729 3.861,2.758 3.851,2.785 C3.808,2.92 3.686,3.019 3.544,3.019 L3.534,3.019 C3.369,3.016 3.234,2.897 3.217,2.738 C3.217,2.725 3.214,2.715 3.214,2.702 C3.214,1.61 2.323,0.653 1.31,0.653 L0.327,0.653 C0.148,0.653 0,0.508 0,0.326 C0,0.148 0.145,0 0.327,0 L1.313,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.082,0.00373643763 C8.765,0.306736438 9.982,1.77273644 9.982,3.48473644 C9.979,5.43873644 8.395,7.02573644 6.445,7.02573644 L0.327,7.02573644 C0.149,7.02573644 0,6.88073644 0,6.69873644 C0,6.51773644 0.146,6.37273644 0.327,6.37273644 L6.445,6.37273644 C8.036,6.37273644 9.332,5.07873644 9.332,3.48473644 C9.332,2.08873644 8.336,0.894736438 6.966,0.646736438 C6.788,0.613736438 6.673,0.445736438 6.702,0.267736438 C6.735,0.0897364376 6.907,-0.0222635624 7.082,0.00373643763 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1515.0 -343.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1530.0 358.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.0000000000001137 -1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1,1 30.984,1 30.984,30.984 1,30.984 1,1",
    stroke: "none",
    fill: "#2795E3"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.235999999999876 9.066000000000031)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 3.678829473857263)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-3.22693261e-14 8.392,-3.22693261e-14 8.392,7.30997053 0,7.30997053 0,-3.22693261e-14",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.448300000000131 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.14190254,0 7.14190254,4.333 0,4.333 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.952700000000164 1.587899999999877)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.87,0 3.87,3.019 0,3.019 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.474300000000085 3.963063562369939)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-4.1855408e-14 9.982,-4.1855408e-14 9.982,7.02573644 0,7.02573644 0,-4.1855408e-14",
    stroke: "none",
    fill: "#2795E3"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudVictim);
export default __webpack_public_path__ + "static/media/cloud-victim.0a3e72dc8ec7df37fcd48436d9d4dc82.svg";
export { ForwardRef as ReactComponent };